// Project briefs on 99designs do not currently support ClientConfiguredField questions.
// At this point in time, ClientConfiguredField questions are only available
// for the `libs/feature-design-services-brief`.
export function Edit() {
    return <div>Not yet implemented</div>;
}

export function View() {
    return <div>Not yet implemented</div>;
}

export function HasValue(): boolean {
    return false;
}

export function getValue() {
    return '';
}
